let grecaptcha = null;
let sitekey = null;
let element = null;
let token = null;

export default {
  load() {
    if (typeof window.grecaptcha === 'undefined') {
      const div = document.createElement('div');
      const idAttrubute = document.createAttribute('id');
      idAttrubute.value = 'g-recaptcha';
      div.setAttributeNode(idAttrubute);
      const dataAttribute = document.createAttribute('data-size');
      dataAttribute.value = 'invisible';
      div.setAttributeNode(dataAttribute);
      document.querySelector('body').appendChild(div);

      const node = document.createElement('script');
      const url = new URL(
        'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoaded&render=explicit'
      );
      node.src = url.href;
      node.defer = true;
      node.async = true;
      const body = document.querySelector('body');
      body.focus();
      body.appendChild(node);
    }
  },

  configure(options = {}) {
    if (!options.element || !options.sitekey) {
      throw 'InvalidConfig';
    }
    element = options.element;
    sitekey = options.sitekey;
  },

  set grecaptcha(value) {
    grecaptcha = value;
  },

  get grecaptcha() {
    return grecaptcha;
  },

  set token(value) {
    token = value;
    this.reset();

    if (this.onToken) {
      this.onToken.call(this, value);
    }
  },

  get token() {
    return token;
  },

  render() {
    if (!grecaptcha || !element || !sitekey) {
      throw 'InvalidConfig';
    }
    document.querySelector('body').focus();
    grecaptcha.render(element, {
      sitekey: sitekey,
      callback: 'onRecaptchaCallback',
    });
  },

  execute() {
    if (!grecaptcha) {
      throw 'RecaptchaUnavailable';
    }
    grecaptcha.execute();
  },

  reset() {
    if (!grecaptcha) {
      throw 'RecaptchaUnavailable';
    }
    grecaptcha.reset();
  },
};
